import personaControlStore from '../store/Store';
import setPersonaBlobFetchStatus from '../actions/setPersonaBlobFetchStatus';
import shouldFetchPersonaPhoto from './shouldFetchPersonaPhoto';
import { action } from 'satcheljs/lib/legacy';
import { getConfig } from 'owa-service/lib/config';
import { HttpReadyState } from 'owa-http-status-codes';
import { isOpx } from 'owa-opx';
import { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';
import { PersonaSize } from 'fabric-persona';

const minBlobSize = 100;
const emailParamId = 'email';
const personIdParamId = 'personId';
const userActionParamId = 'UA';
const sizeParamId = 'size';
const serviceEndpoint = '/service.svc/s/GetPersonaPhoto';

// The following mapping is based on the supported sizes for persona photo present in enum UserPhotoSizeType at following location.
// https://o365exchange.visualstudio.com/O365%20Core/_git/Griffin?path=%2Fsources%2Fdev%2Fassistant%2Fsrc%2Fcore%2FExchangeWebservices.cs&_a=contents&version=GBmaster
const personaToImageSize = {
    [PersonaSize.extraExtraSmall]: 'HR64x64',
    [PersonaSize.size28]: 'HR64x64',
    [PersonaSize.tiny]: 'HR64x64',
    [PersonaSize.extraSmall]: 'HR64x64',
    [PersonaSize.small]: 'HR64x64',
    [PersonaSize.smallPlus]: 'HR64x64',
    [PersonaSize.regular]: 'HR64x64',
    [PersonaSize.regularPlus]: 'HR120x120',
    [PersonaSize.large]: 'HR120x120',
    [PersonaSize.extraLarge]: 'HR240x240',
};

export function calculatePhotoUrl(
    emailAddress: string,
    personaId: string,
    personaSize: PersonaSize
): string {
    // TODO VSO 1194: handle consumer case differently
    let paramString = '';
    if (emailAddress) {
        paramString = appendUrlParam(paramString, emailParamId, emailAddress);
    } else if (personaId) {
        paramString = appendUrlParam(paramString, personIdParamId, personaId);
    }
    paramString = appendUrlParam(paramString, userActionParamId, '0');
    paramString = appendUrlParam(paramString, sizeParamId, personaToImageSize[personaSize]);
    return `${getConfig().baseUrl}${serviceEndpoint}?${paramString}`;
}

function appendUrlParam(paramString: string, paramId: string, inputParamValue: string): string {
    if (!paramId) {
        return undefined;
    }
    let paramValue = inputParamValue;
    if (paramValue) {
        paramValue = encodeURIComponent(paramValue);
    }
    let newParamString = `${paramId}=${paramValue}`;
    if (paramString) {
        newParamString = `${paramString}&${newParamString}`;
    }
    return newParamString;
}

const downloadPersonaPhoto = async (personaControlKey: string) => {
    if (!shouldFetchPersonaPhoto(personaControlKey)) {
        return;
    }
    const viewState = personaControlStore.viewStates.get(personaControlKey);
    setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Pending);
    const request = new XMLHttpRequest();

    const photoUrl = calculatePhotoUrl(
        viewState.emailAddress,
        viewState.personaId,
        viewState.personaSize
    );
    const personaBlob = viewState.personaBlob;
    request.open('GET', photoUrl, true);
    if (isOpx()) {
        const token = await getConfig().getAuthToken();
        request.setRequestHeader('authorization', token);
    }
    request.responseType = 'blob';
    request.onreadystatechange = function () {
        if (request.readyState === HttpReadyState.Done) {
            let blob: any = null;
            let isBlob = false;

            if (request.status === 200) {
                blob = request.response;
                const contentType = request.getResponseHeader('Content-Type');
                isBlob =
                    contentType &&
                    contentType.toLowerCase().indexOf('image') === 0 &&
                    blob instanceof Blob;
            }

            <any>action('getPersonaPhoto:getPersonaPhotoCallback')(() => {
                if (isBlob && blob && blob.size > minBlobSize) {
                    personaBlob.blobUrl = URL.createObjectURL(blob);
                    // Bookkeeping the all the persona photos browser has cached.
                    setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Success);
                    return;
                } else {
                    setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Failed);
                    if (request.status > 399) {
                        throw 'Request failed statusCode: ' + request.status;
                    }
                }
            })();
        }
    };

    request.ontimeout = () => {
        setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Failed);
        throw new Error('Request timed out');
    };

    request.onerror = e => {
        setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Failed);
        throw new Error(request.statusText);
    };

    request.send();
};

export default downloadPersonaPhoto;
